<template>
  <b-row
    v-show="visible"
    no-gutters
    class="waitBlock justify-content-center">
    <span
      v-if="waitPeople.length == 1"
      class="waitBlockText">
      {{ waitPeople[0].firstName + " " + waitPeople[0].lastName + $t('MEETING.WAITING_JOINED_SINGLE') }}
    </span>
    <span
      v-if="waitPeople.length > 1"
      class="waitBlockText">
      {{ waitPeople.length + " " + $t('MEETING.WAITING_JOINED_MULTIPLE') }}
    </span>
    <div
    class="d-flex justify-content-between">
      <button
        v-if="!expanded"
        style="margin-left:16px"
        class="btn-sm btn btn-grey"
        @click="$parent.$parent.$refs.sideBar.toggleBar('participants')">
      {{ $t('MEETING.WAITING_VIEW') }}</button>
      <button
        style="margin-left:16px"
        class="btn-sm btn btn-grey"
        @click="admitFromWatingRoom(waitPeople)">
      {{ $t('MEETING.WAITING_ADMIT') }}</button>
      <div
        style="margin-left: 16px; cursor: pointer"
        @click="showWaitPopup=!showWaitPopup"
      >
        <close-icon :size="10"/>
      </div>
    </div>
  </b-row>
</template>

<script>
import { ref, watch } from "@vue/composition-api"
import CloseIcon from "../icons/Close"
export default {
  name: 'WaitingBlueBar',
  components: {
    'close-icon': CloseIcon
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    waitPeople: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    function admitFromWatingRoom(waitingPeople) {
      waitingPeople.forEach( person => {
        context.parent.$parent.admitFromWatingRoom(person.id)
      })
    }
    
    return {
      admitFromWatingRoom
    }
  }
}
</script>
<style>
.waitBlock {
    position: absolute;
    padding: 4px 12px;
    border-radius: 4px;
    z-index: 300;
    background-color: #0072E5;
    left: 50%;
    width: auto;
    transform: translateX(-50%);
  }
  .waitBlockText {
    font-size: 14px;
    font-weight: 600;
    color: #FFFFFF;
  }
</style>


// WEBPACK FOOTER //
// src/components/WaitingBlueBar.vue